const updateMask = (element, url) => {
	if (window.browser === 'Safari') {
		element.style.maskImage = 'none'
		element.offsetWidth //force a style recalculation
		element.style.maskImage = `var(--section-mask-url, url(#${url})), linear-gradient(transparent 0%, transparent var(--mask-position, 0%), black var(--mask-position, 0%), black 100%)`
	}
}

export {
	updateMask,
}
